/**
 * DevExtreme (esm/__internal/scheduler/utils/is_scheduler_component.js)
 * Version: 23.1.5
 * Build date: Wed Aug 30 2023
 *
 * Copyright (c) 2012 - 2023 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
var schedulerComponentName = "dxScheduler";
export function isSchedulerComponent(component) {
    return component.NAME === schedulerComponentName
}
